// extracted by mini-css-extract-plugin
module.exports = {"horizontal-group":"a2c79c7e7d--horizontal-group--o1T8f","vertical-group":"a2c79c7e7d--vertical-group--kz0pR"};